import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Buttons = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    gap: 16px;
    margin-top: 24px;
    justify-content: flex-end;

    @media (max-width: ${theme.screenSizes.laptop}) {
      flex-direction: column-reverse;
      align-items: center;
      justify-content: flex-end;
      gap: 16px;
    }
  `}
`
